import React from 'react';
import { useOutletContext } from 'react-router-dom';

export default function TeacherLandingOffer() {
  const { content } = useOutletContext();
  const legal = content.legal;
  const p = legal.provider;

  return (
    <main>
      <section className="tl-legal-hero">
        <div className="tl-wrap">
          <span className="tl-badge">{legal.badge}</span>
          <h1 className="tl-serif tl-h1" style={{ marginTop: '1rem' }}>
            {legal.title}
          </h1>
          <p className="tl-lead tl-legal-intro">{legal.intro}</p>
          <p className="tl-legal-meta">
            {legal.updatedLabel}: <span>{legal.updatedAt}</span>
          </p>
          {legal.stubNotice ? (
            <p className="tl-legal-stub-notice" role="note">
              {legal.stubNotice}
            </p>
          ) : null}
        </div>
      </section>

      <section className="tl-section">
        <div className="tl-wrap tl-legal-layout">
          <nav className="tl-legal-toc" aria-label={legal.tocLabel}>
            <p className="tl-eyebrow">{legal.tocLabel}</p>
            <ol>
              <li>
                <a href="#legal-contacts">{p.heading}</a>
              </li>
              {legal.sections.map((s) => (
                <li key={s.id}>
                  <a href={`#legal-${s.id}`}>{s.title}</a>
                </li>
              ))}
            </ol>
          </nav>

          <div className="tl-legal-body">
            <article id="legal-contacts" className="tl-legal-block">
              <h2 className="tl-serif">{p.heading}</h2>
              <dl className="tl-legal-dl">
                <div>
                  <dt>{p.legalNameLabel}</dt>
                  <dd>{p.legalName}</dd>
                </div>
                <div>
                  <dt>{p.taxIdLabel}</dt>
                  <dd>{p.taxId}</dd>
                </div>
                <div>
                  <dt>{p.legalAddressLabel}</dt>
                  <dd>{p.legalAddress}</dd>
                </div>
                <div>
                  <dt>{p.actualAddressLabel}</dt>
                  <dd>{p.actualAddress}</dd>
                </div>
                <div>
                  <dt>{p.phoneLabel}</dt>
                  <dd>{p.phone}</dd>
                </div>
                <div>
                  <dt>{p.emailLabel}</dt>
                  <dd>{p.email}</dd>
                </div>
              </dl>
            </article>

            {legal.sections.map((s) => (
              <article key={s.id} id={`legal-${s.id}`} className="tl-legal-block">
                <h2 className="tl-serif">{s.title}</h2>
                {s.paragraphs.map((text, i) => (
                  <p key={`${s.id}-p-${i}`}>{text}</p>
                ))}
                {s.list?.length ? (
                  <ul>
                    {s.list.map((item, i) => (
                      <li key={`${s.id}-li-${i}`}>{item}</li>
                    ))}
                  </ul>
                ) : null}
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
